export default function CompletenessModalTableColumsSettings() {
	return [
		{
			name: "num",
			title: "№",
			width: "45px",
			cellHorAlign: "center",
			headHorAlign: "center",
			headHeight: "22px",
			marginLeft: "1px",
			sort: true,
		},
		{
			name: "estm_name",
			title: "Сметный документ",
			width: "200px",
			cellHorAlign: "left",
			headHorAlign: "left",
			headHeight: "22px",
			marginLeft: "1px",
			sort: true,
		},
		{
			name: "state_name",
			title: "Проверка",
			width: "300px",
			cellHorAlign: "left",
			headHorAlign: "left",
			colSpan: "2",
			headHeight: "22px",
			marginLeft: "1px",
			sort: true,
		},
		{
			name: "text",
			title: "Описание ошибки",
			width: "auto",
			cellHorAlign: "left",
			headHorAlign: "left",
			colSpan: "2",
			headHeight: "22px",
			marginLeft: "1px",
			sort: true,
			filter: true,
			filterWidth: "300px",
			filterAlwaysOpen: true,
		},
	];
}
